import { useMemo } from 'react';
import { useBusinessUnitStore } from '../../contexts/mobx';
import { COUCHE_TARD_PROVINCES } from '../../types/app-selection';

interface ProvinceSelection {
    provinceId: number;
}

export const useDeepLinkVisibility = (
    selectedProvinces: ProvinceSelection[]
) => {
    const businessUnitStore = useBusinessUnitStore();

    return useMemo(() => {
        if (!selectedProvinces.length || !businessUnitStore.businessUnits) {
            return { showCoucheTard: false, showCircleK: false };
        }

        // Build a lookup map: provinceId → province code
        const provinceIdToCode = new Map<number, string>();
        for (const bu of businessUnitStore.businessUnits) {
            for (const province of bu.provinces) {
                provinceIdToCode.set(province.id, province.name);
            }
        }

        let showCoucheTard = false;
        let showCircleK = false;

        for (const { provinceId } of selectedProvinces) {
            const code = provinceIdToCode.get(provinceId);
            if (!code) continue;

            if ((COUCHE_TARD_PROVINCES as readonly string[]).includes(code)) {
                showCoucheTard = true;
            } else {
                showCircleK = true;
            }

            if (showCoucheTard && showCircleK) break;
        }

        return { showCoucheTard, showCircleK };
    }, [selectedProvinces, businessUnitStore.businessUnits]);
};
